var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:_vm.classStyle,attrs:{"title":_vm.title,"disabled":_vm.disabled,"block":_vm.block,"color":"secondary","rounded":""},on:{"click":function($event){return _vm.submitEmit()}}},[_c('span',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }